import React from 'react';
import { withAnalyticsContext, withAnalyticsEvents } from '@atlaskit/analytics-next';
import { CardWithDataRenderer } from '../CardWithData/loader';
import { CardWithURLRenderer } from '../CardWithUrl/loader';
import { isCardWithData } from '../../utils';
import { context } from '../../utils/analytics';
import { injectIntl, IntlProvider } from 'react-intl-next';

class PlainCard extends React.PureComponent {
  render() {
    const content = isCardWithData(this.props) ? /*#__PURE__*/React.createElement(CardWithDataRenderer, this.props) : /*#__PURE__*/React.createElement(CardWithURLRenderer, this.props);
    return this.props.intl ? content : /*#__PURE__*/React.createElement(IntlProvider, {
      locale: "en"
    }, content);
  }

}

export const Card = withAnalyticsContext(context)(withAnalyticsEvents()(injectIntl(PlainCard, {
  enforceContext: false
})));